import React, {ChangeEventHandler, FocusEventHandler, MouseEventHandler, MutableRefObject} from "react"
import styles from "./input-field.module.scss"
import {ValidationResult} from "../../util/validation/validation-result"
import MaterialIcon from "../material-icon/material-icon-view"

export interface InputProps {
  readonly id?: string
  readonly type?: string
  readonly value: string
  readonly disabled?: boolean
  readonly readOnly?: boolean
  readonly showValidity?: boolean
  readonly validationResult: ValidationResult
  readonly onChange?: ChangeEventHandler<HTMLInputElement>
  readonly onBlur?: FocusEventHandler<HTMLInputElement>
  readonly onClick?: MouseEventHandler<HTMLInputElement>
  readonly testId?: string
  readonly forwardRef?: MutableRefObject<any>
}

export const InputField: React.FC<InputProps> = ({id, type = "text", value, disabled, readOnly, showValidity, validationResult: {valid}, onChange, onBlur, onClick, testId, forwardRef}) => {
  let inputClassName: string

  if (showValidity && !disabled)
    inputClassName = valid ? styles.InputValid : styles.InputInvalid
  else
    inputClassName = styles.Input

  return (
    <div className={styles.InputContainer}>
      <input data-hj-suppress={true}
             type={type}
             id={id}
             value={type === "file" ? undefined : value}
             disabled={disabled}
             readOnly={readOnly}
             className={inputClassName}
             onChange={onChange}
             onBlur={onBlur}
             onClick={onClick}
             data-testid={testId}
             ref={forwardRef}/>

      <div hidden={!showValidity}
           className={valid ? styles.InputIconContainerValid : styles.InputIconContainerInvalid}>
        <MaterialIcon name={valid ? "check" : "error"}/>
      </div>
    </div>
  )
}

// export const FileInputField: React.FC<InputProps> = ({id, value, disabled, readOnly, showValidity, validationResult: {valid}, onChange, onBlur, onClick, testId, ref}) => {
//   let inputClassName: string
//
//   if (showValidity && !disabled)
//     inputClassName = valid ? styles.InputValid : styles.InputInvalid
//   else
//     inputClassName = styles.Input
//
//   return (
//     <div className={styles.InputContainer}>
//       <input data-hj-suppress={true}
//              type="file"
//              id={id}
//              value={value}
//              disabled={disabled}
//              readOnly={readOnly}
//              className={inputClassName}
//              onChange={onChange}
//              onBlur={onBlur}
//              onClick={onClick}
//              data-testid={testId}
//              ref={ref}/>
//
//       <div hidden={!showValidity}
//            className={valid ? styles.InputIconContainerValid : styles.InputIconContainerInvalid}>
//         <MaterialIcon name={valid ? "check" : "error"}/>
//       </div>
//     </div>
//   )
// }
